// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","LoadingSwitch":"bhq_a big_ea big_a","LoadingSwitch__init":"bhq_b big_a big_w big_j big_ul big_um big_fm"};